export * from './lib/vehicle-assignment-form';
